<template>
  <v-main>
    <v-row>
      <v-col>
        <v-card-title>
          Asset List
          <v-spacer></v-spacer>
        </v-card-title>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
            label="Date"
            class="mb-2"
            v-model="date"
            @change="dateChange()"
            hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
            label="Program"
            class="mb-2"
            v-model="program"
            @change="programChange()"
            hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
            :headers="headers"
            :items="desserts"
            class="elevation-1"
            fixed-header
            :loading="loadAssets"
            :search="search"
            :footer-props="{
    'items-per-page-options': [50, 100 , 200, -1]
  }"
        >
          <template v-slot:item.url="{ item }">
            <a :href="item.url" style="text-decoration: none" target="_blank">{{ item.url }}</a>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
                :color="getColor(item.status)"
                dark
            >
              {{ item.status }}
            </v-chip>
          </template>
          <template v-slot:item.title="{ item }">
            {{ item.title.substring(0, 20) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
                x-small
                @click="sendToScanner(item)"
                text
                color="primary"
            >
              Scan
            </v-btn>
            <v-btn
                x-small
                @click="sendToFuzzer(item)"
                text
                color="primary"
            >
              Fuzz
            </v-btn>
          </template>

        </v-data-table>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
export default {
  name: "AssetList",
  data() {
    return {
      post: '',
      date: 24,
      program: "",
      snackbar: false,
      loadAssets: true,
      search: "",
      headers: [
        {text: 'URL', value: "url", sortable: false},
        {text: 'Status', value: "status"},
        {text: 'Program', value: "scope"},
        {text: 'CL', value: "header.content-length"},
        {text: 'IP', value: "ip"},
        {text: 'Title', value: "title"},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      desserts: [],
    }
  },
  methods: {
    getColor(calories) {
      if (calories > 499) return 'red'
      else if (calories > 399) return 'orange'
      else if (calories > 299) return 'blue'
      else return 'green'
    },
    dateChange: function () {
      this.loadAssets = true
      this.desserts = []
      this.axios.get('https://isee.sh:2087/asset/data/find?&full=true&date=' + this.date).then(response => {
        this.desserts = response.data
        this.loadAssets = false
      })
    },
    programChange: function () {
      this.loadAssets = true
      this.desserts = []
      this.axios.get('https://isee.sh:2087/asset/data/find?&full=true&date=' + this.date + '&scope=' + this.program).then(response => {
        this.desserts = response.data
        this.loadAssets = false
      })
    },
    sendToScanner: function (item) {
      this.axios.get('https://isee.sh:2087/scanner/task/run?url=' + item.url)
    },
    sendToFuzzer: function (item) {
      this.axios.get('https://isee.sh:2087/fuzzer/task/run?url=' + item.url + '&asset='+item.url)
    }
  },
  mounted() {
    this.axios.get('https://isee.sh:2087/asset/data/find?full=true&date=' + this.date).then(response => {
      this.desserts = response.data
      this.loadAssets = false
    })
  },
}
</script>

<style scoped>


</style>
